<template>
  <div class="anc-form">
    <div class="anc-form-title"> {{ formTitle }}</div>
    <div class="anc-form-body">

          <div class="data-row">
             <label for="Title"
             :class="(announcement.title)? '': 'required'">Title</label>
            <input name="Title" class="e-input i-input" type="text" placeholder="Title"
            v-model="announcement.title"/>

          </div>

        <div class="data-row">
         <label for="Message"
         :class="(announcement.body)? '': 'required'">Message</label>
         <ejs-richtexteditor
         name="Message"
            :quickToolbarSettings="quickToolbarSettings"
            :height="200"
            v-model="announcement.body"
            :fontFamily="fontFamily"
            :toolbarSettings="toolbarSettings"
          >
          </ejs-richtexteditor>
        </div>

        <div class="data-row">
         <label for="name"  :class="(announcement.title)? '': 'required'">Display Period</label>
            <div class="dt-start">
            <ejs-datetimepicker class="i-input col" placeholder="Start Date"
            v-model="announcement.startDate"></ejs-datetimepicker>
            </div>
            <div class="dt-end">
            <ejs-datetimepicker class="i-input col" placeholder="End Date"
            v-model="announcement.endDate"></ejs-datetimepicker>
          </div>
        </div>

       <div class="data-row comments-box">
          <!-- <label for="Comments">Comments</label> -->
         <ejs-textbox
                    name="Comments"
                    placeholder="Comments.."
                    :multiline="true"
                    rows=4
                    v-model="announcement.comments"
                    />
        </div>

      <!-- <div class="data-row">
        <ejs-checkbox label='disabled'></ejs-checkbox>
      </div> -->

    </div>
    <div class="anc-form-footer" >
      <div class="btn-container">
        <ejs-button type="button" @click.native="onSaveClick"
                    cssClass="e-info margin-button">Submit</ejs-button>
        <ejs-button style="margin-left:8px;" @click.native="onCancelClick"
                    cssClass="e-warning margin-button">Cancel</ejs-button>
       <ejs-button v-if="isEditForm" style="margin-left:8px;" @click.native="onDeleteClick"
                    cssClass="e-warning margin-button">Delete</ejs-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  RichTextEditorPlugin, Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar,
} from '@syncfusion/ej2-vue-richtexteditor';
import { DateTimePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import { CheckBoxPlugin } from "@syncfusion/ej2-vue-buttons";
import richTextEditorConfig from "../../../uicontrol.config";
import { announcementsAdminApi } from '../services/announcements-api';

Vue.use(RichTextEditorPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(CheckBoxPlugin);

const FormTypes = { new: 1, edit: 2 };

export default {
  name: "AnnouncementForm",
  data() {
    return {
      formType: FormTypes.new,
      formTitle: "New Announcement",
      announcement: {},
      fontFamily: richTextEditorConfig.fontFamilySettings,
      quickToolbarSettings: richTextEditorConfig.quickToolbarSettings,
      toolbarSettings: richTextEditorConfig.toolbarSettings,
    };
  },
  computed: {
    isEditForm() {
      return this.formType === FormTypes.edit;
    },
  },
  async created() {
    const id = this.$route.params?.id;
    if (id) this.setFormForEdit(id);
  },
  methods: {
    async setFormForEdit(id) {
      const aPromise = announcementsAdminApi.getById(id);
      this.formTitle = "Edit Annoucement";
      this.formType = FormTypes.edit;
      this.announcement = await aPromise;
      if (!this.announcement) {
        this.showMessage('Failed!', 'Record not found.');
        this.closeForm();
      }
    },
    isFormValid() {
      return (this.announcement.title
      && this.announcement.body
      && this.announcement.startDate
      && this.announcement.endDate);
    },
    async onSaveClick(e) {
      e.preventDefault();

      if (this.isFormValid()) {
        let opResult = null;
        if (this.announcement.id) opResult = await announcementsAdminApi.update(this.announcement);
        else opResult = await announcementsAdminApi.save(this.announcement);

        if (opResult && opResult.status === 'success') {
          this.showMessage('Success!', 'Successfully saved.', true);
          this.closeForm();
        } else this.showMessage('Failed!', 'Unable to save data.');
      } else this.showMessage('Validation failed!', 'Please fill all the required fields');
    },
    async onDeleteClick(e) {
      e.preventDefault();

      const opResult = await announcementsAdminApi.delete(this.announcement.id);

      if (opResult && opResult.status === 'success') {
        this.showMessage('Success!', 'Successfully deleted.', true);
        this.closeForm();
      } else this.showMessage('Failed!', 'Delete operation failed.');
    },
    async onCancelClick() {
      this.closeForm();
    },
    closeForm() {
      this.$router.push(`/announcements`);
    },

    // Refactor: notifications should be a separate global service
    showMessage(title, message, isSuccess = false) {
      const cssClass = isSuccess ? 'e-toast-success' : 'e-toast-danger';
      this.$parent.notificationToasts.push({
        title,
        content: message,
        cssClass,
        timeOut: 5000,
      });
      this.$parent.$refs.notifierRef.show();
    },
  },
  provide: {
    richtexteditor: [Toolbar, Link, Image, Count, HtmlEditor, QuickToolbar],
  },
};
</script>

<style scoped>
.comments-box {
  background-color: #f4f7f9;
    padding: 20px;
}
.dt-start, .dt-end {
  margin-right: 20px;
  max-width: 230px;
  display: inline-block;
  width: 40%;
  position: relative;
}

.anc-form-body {
    padding: 10px 30px;
}
.anc-form {
  font-size: 13px;
 width:95%;
    margin:0 auto;
    /* border: 1px solid silver; */
    border-radius: 3px;
    box-shadow: 1px 7px 10px 0px #edf0f3;
}
.anc-form-title {
       font-size: 24px;
    padding: 20px 30px;
    margin-top: 30px;
    background: #f4f7f9;
    color: #5e79a9;
    font-weight: 600;
    font-family: system-ui;
}
.btn-container {
  text-align: center;
  padding: 20px;
  margin-bottom: 20px;
}

.data-row {
    float: left;
    margin-right: 20px;
    width: 100%;
    margin-bottom: 25px;
    position: relative;
}
input,label {
  display: block;
}
.data-row>label {
    margin-bottom: 10px;
    font-weight: 600;
}
.required::after {
    content: "*";
    color: red;
    /* position: absolute; */
    margin-left: 3px;
}
</style>
